import { inject, Injectable } from '@angular/core';
import { AssetsService } from './assets.service';
import { mergeMap, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TextResourceService {
  private readonly assetsService = inject(AssetsService);

  getFromDefaultJSON(fullName: string): Observable<string> {
    return this.getFromJSON('static/ewnioski/texts/resources.json', fullName);
  }

  getObjectFromDefaultJSON(fullName: string): Observable<any> {
    return this.getFromJSON(
      'static/ewnioski/texts/resources.json',
      fullName,
      true,
    );
  }

  getFromErrorJSON(fullName: string): Observable<string> {
    return this.getFromJSON(
      'static/ewnioski/texts/error-messages.json',
      fullName,
    );
  }

  getFromJSON(
    jsonPath: string,
    fullName: string,
    allowObject = false,
  ): Observable<string | any> {
    return this.assetsService.getJson(jsonPath).pipe(
      mergeMap((rootObject: any) => {
        if (fullName == null) {
          return of(null);
        } else if (typeof fullName !== 'string') {
          // to powinien być string, ale nie zawsze nim jest
          return of(fullName);
        }

        const currentField = this.getField(rootObject, fullName, allowObject);

        if (currentField instanceof Observable) {
          return currentField;
        } else if (typeof currentField === 'object') {
          const plikHTML = currentField['plikHTML'] ?? currentField['plikHtml'];
          if (plikHTML) {
            return this.assetsService.getText(plikHTML);
          } else if (allowObject) {
            return of(currentField);
          } else {
            return of(fullName);
          }
        } else {
          return of(currentField);
        }
      }),
    );
  }

  private getField(
    rootObject: Object,
    fullName: string,
    allowObject = false,
  ): any | Observable<string> {
    let currentField = rootObject;
    let currentFieldName = '';
    let currentFieldFullName = '';

    const partsOfFullName: string[] = fullName.split('.');

    for (const currentPart of partsOfFullName) {
      if ((currentField as any)[currentPart]) {
        // standardowe przechodzenie do nastepnego pola
        currentFieldName = currentPart;

        // budowanie pelnej nazwy aktualnego pola
        if (currentFieldFullName.length !== 0) {
          currentFieldFullName += '.';
        }
        currentFieldFullName += currentPart;

        currentField = (currentField as any)[currentPart];
      } else if ((currentField as any)['import']) {
        if (typeof (currentField as any)['import'] !== 'string') {
          return fullName;
        } else {
          // jest import wiec przygotowujemy relatywną nazwę
          const newFullName = fullName.replace(currentFieldName + '.', '');
          const newJSONPath = (currentField as any)['import'];

          return this.getFromJSON(newJSONPath, newFullName, allowObject);
        }
      } else {
        return fullName;
      }
    }

    return currentField;
  }
}
